module.exports = __webpack_public_path__ + "static/img/Onto-electric.78517db6.png";